import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './artwork-tile.component.scss';
var ArtworkTile = /** @class */ (function (_super) {
    tslib_1.__extends(ArtworkTile, _super);
    function ArtworkTile(element) {
        return _super.call(this, element) || this;
    }
    ArtworkTile.prototype.init = function () {
    };
    ArtworkTile.prototype.bindEvents = function () {
    };
    return ArtworkTile;
}(Base));
export { ArtworkTile };



//////////////////
// WEBPACK FOOTER
// ./components/artwork-tile/artwork-tile.component.ts
// module id = 114
// module chunks = 0